





























































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { searchUsers, CruisePlanTeamMemberData } from '@/api/cruisePlan/index'
import FormDialog from '@/components/dialog/formDialog.vue'
import { enLookupType, enFirstType } from '@/configs/enums'
import { DDLItem, getLookupByType } from '@/api/common/select'
import { getDDLItem, getDDLName } from '@/configs/functions'

import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
const UserModule = namespace('user')
@Component({
  components: {
    FormDialog
  }
})
export default class CruisePlanSelectUsers extends Vue {
  @UserModule.Getter('userInfo')
  public curUser!: UserData
  public name = "CruisePlanSelectUsers"

  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void

  public showDialog: boolean = false
  public loading: boolean = false

  public teamType: number = 0 //0本级单位 1巡防组织
  public teamId: number = 0
  public teamList: DDLItem[] = []
  public memberList: DDLItem[] = []
  public selectedMembers: number[] = []

  public mounted() {
    window.eventBus.$on("openCruisePlanSearchUsers", () => {
      this.open()
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("openCruisePlanSearchUsers")
  }
  public open() {
    this.showDialog = true
    if (this.teamList.length == 0) {
      getLookupByType(enLookupType.CruiseTeam, enFirstType.None).then(
        (response: { data: any }) => {
          const data = response.data
          if (data) {
            this.teamList = data
          }
        }
      )
    }
    this.teamType = 0
    this.teamTypeChange()
    // this.doSearch()
  }

  public teamTypeChange() {
    this.teamId = 0
    if (this.teamType > 0) {
      if (this.teamList.length == 0) {
        this.$message({ type: 'warning', message: '没有巡防组织可以选择' })
        this.teamId = 0
        this.teamType = 0
      }
      else {
        this.teamId = this.teamList[0].Key
      }
    }
    this.teamChange()
  }
  public teamChange() {
    this.selectedMembers = []
    this.memberList = []
    this.fetchData()
  }
  public close() {
    this.showDialog = false
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  // 查询用户所在地的文保单位
  public doSearch() {
    this.fetchData()
  }
  public fetchData() {
    this.loading = true
    searchUsers(this.teamId).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.memberList = data
        this.loading = false
      }
    })
  }
  public sendData(data: CruisePlanTeamMemberData[]) {
    window.eventBus.$emit("submitCruisePlanSearchUsers", data)
  }
  // 确定事件
  public onSubmit() {
    const referId = this.teamId == 0 ? this.curUser.Id : this.teamId
    //1:本级单位  2:巡防组织  3:巡查人员
    let referType = this.teamId == 0 ? 1 : 2
    const referName = this.teamId == 0 ?
      (this.curUser.CityName + this.curUser.CountyName) :
      getDDLName(this.teamList, referId)
    var list: CruisePlanTeamMemberData[] = []
    if (this.selectedMembers.length > 0) {
      // referType = 3
      list = this.selectedMembers.map((v: number) => {
        return {
          Id: 0, CruisePlanId: 0, ReferType: referType, ReferId: referId, ReferName: referName,
          CruiserId: v, CruiserName: getDDLName(this.memberList, v)
        }
      })
    }
    else {
      list.push({
        Id: 0, CruisePlanId: 0, ReferType: referType, ReferId: referId, ReferName: referName,
        CruiserId: 0, CruiserName: ''
      })
    }
    console.log('search users', list)
    //回传给父组件
    this.sendData(list)
    this.showDialog = false
  }
}
